// Text atom component
export const Text = ({
  children,
  className = "",
  size = "base",
  color = "gray-700",
  ...props
}) => {
  const sizes = {
    sm: "text-sm",
    base: "text-base",
    lg: "text-lg",
    xl: "text-xl",
  };

  return (
    <p className={`${sizes[size]} text-${color} ${className}`} {...props}>
      {children}
    </p>
  );
};
